import { useTranslation } from 'react-i18next';
import sprayPurpleTexture from 'assets/images/texture-grained-bg.webp';
import { Heading } from 'components/Typography';

export const SupportHero = () => {
  const { t } = useTranslation();
  return (
    <div
      style={{ backgroundImage: `url(${sprayPurpleTexture})` }}
      className="relative rounded-md p-32 bg-white md:p-40 bg-cover bg-center min-h-[202px] flex justify-center items-center mb-40"
    >
      <div>
        <Heading level="h2" className="text-center mb-24">
          {t('support.hero.heading')}
        </Heading>

        <Heading level="h5" as="p" className="text-base font-normal text-center">
          {t('support.hero.subHeading')}
        </Heading>
      </div>
    </div>
  );
};
